import React, { useState, useEffect, useCallback } from "react";
import "./PopeyeShipmentUpdate.scss";
import "../ShipmentManagement/ShipmentManagement.scss";
import "../ShipmentManagement/ShipmentManagementHeader/ShipmentManagementHeader.scss";
import PopeyeShipmentUpdateElements from "../PopeyeShipmentUpdate/PopeyeShipmentUpdateElements/PopeyeShipmentUpdateElements";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const PopeyeShipmentUpdate = ({ selectedShipment }) => {
  return (
    <div className="PopeyeShipmentUpdate">
      <TransitionGroup>
        <CSSTransition
          key={selectedShipment ? selectedShipment.id : "no-shipment"}
          timeout={500} // Should match the duration of your CSS transition
          classNames="shipment"
        >
          <div className="shipment-container">
            {selectedShipment ? (
              <PopeyeShipmentUpdateElements shipment={selectedShipment} />
            ) : (
              <div>No shipments available.</div>
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};

export default PopeyeShipmentUpdate;
